import { Box, Grid2, Typography } from '@mui/material'
import { useState } from 'react'

import Button from 'components/Button'
import VerificationInput from 'components/VerificationInput'
import theme from 'utils/theme'
import {
  useMutateVerifySoftwareToken,
  useMutateEnableTwoFa
} from 'hooks/useTwoFa'
import { useAuth } from 'components/AuthProvider'

export interface Props {
  setBackupCodes: (value: string[]) => void
}

export default function TwoStepCode({ setBackupCodes }: Props): JSX.Element {
  const { refreshCurrentUser } = useAuth()
  const [otp, setOtp] = useState<string>('')
  const [error, setError] = useState<string>('')

  const verifyMutation = useMutateVerifySoftwareToken()
  const enableMutation = useMutateEnableTwoFa()

  const handleChangeOtpCode = (code: string) => {
    setError('')
    setOtp(code)
  }

  const loading = verifyMutation.isLoading || enableMutation.isLoading

  const handleEnableAuthenticatorApp = () => {
    verifyMutation.mutate(otp, {
      onSuccess: () => {
        enableMutation.mutate(undefined, {
          onSuccess: data => {
            if (data?.backupCodes) {
              setBackupCodes(data.backupCodes)
            }
            void refreshCurrentUser()
          },
          onError: (err: unknown) =>
            setError(
              err instanceof Error
                ? err.message
                : 'Failed to enable authenticator'
            )
        })
      },
      onError: (err: unknown) =>
        setError(
          err instanceof Error ? err.message : 'Invalid verification code'
        )
    })
  }

  return (
    <Grid2 container>
      <Grid2 size={{ xs: 12 }}>
        <Typography
          align='left'
          variant='h2'
          fontSize='48px'
          textTransform='uppercase'
        >
          Enter your code
        </Typography>
      </Grid2>
      <Grid2 mb={4} size={{ xs: 12 }}>
        <Typography align='left' fontSize='medium'>
          Enter the code generated by your auth app below
        </Typography>
      </Grid2>
      <Grid2 sx={{ marginTop: 6 }} size={{ xs: 12 }}>
        <VerificationInput onChange={handleChangeOtpCode} />
      </Grid2>
      <Grid2 sx={{ textAlign: 'center', marginBottom: 6 }} size={{ xs: 12 }}>
        {error && (
          <Box
            sx={{
              color: theme.palette.error.main,
              fontSize: '16px'
            }}
          >
            {error}
          </Box>
        )}
      </Grid2>
      <Grid2 sx={{ mt: 4, textAlign: 'center' }} size={{ xs: 12 }}>
        <Button
          color='primary'
          fullWidth
          onClick={handleEnableAuthenticatorApp}
          disabled={loading}
        >
          Turn on authenticator app
        </Button>
      </Grid2>
    </Grid2>
  )
}
